import { useRequest } from 'ahooks'
import { Table } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { StageSearch } from '@/components'

const { Summary } = Table
const { Row, Cell } = Summary

interface StageAddProps {
  selfId: string
  onSuccess: () => void
  onClose: () => void
}

export const StageAdd: React.FC<StageAddProps> = ({ selfId, onSuccess, onClose }) => {
  const { t } = useTranslation()
  const { run } = useRequest(
    (name) => ({
      url: '/api/project/createProjectStage',
      method: 'post',
      data: {
        name,
        selfId,
      },
    }),
    {
      manual: true,
    }
  )

  return (
    <Row>
      <Cell index={0} />
      <Cell index={1}>
        <StageSearch
          autoFocus
          defaultOpen
          style={{ width: '100%' }}
          placeholder={t('stage.tip')}
          onKeyDown={async (e) => {
            switch (e.nativeEvent.key) {
              case 'Enter': {
                const name = (e.target as HTMLInputElement).value
                if (name) {
                  await run(name)
                  onSuccess()
                }
                break
              }
              case 'Escape': {
                onClose()
                break
              }
            }
          }}
          onBlur={async (e) => {
            const name = (e.target as HTMLInputElement).value
            if (name) {
              await run(name)
              onSuccess()
            } else {
              onClose()
            }
          }}
        />
      </Cell>
      <Cell index={2} />
      <Cell index={3} />
      <Cell index={4} />
      <Cell index={5} />
      <Cell index={6} />
      <Cell index={7} />
    </Row>
  )
}
